import React from 'react';
import VersionList from './VersionList';
import { useParams } from 'react-router-dom';


function VersionsPage() {
    var params = useParams();

    return (
        <div className="main-content">
            <VersionList  w_id={params.w_id} v_id={params.v_id} />
        </div>
    )
}

export default VersionsPage